import tunnel from 'tunnel-rat';

export const MainLayoutPanelTunnel = tunnel();

export const MainLayoutHeaderTunnel = tunnel();
